{
  "page": {
    "loading": "載入競賽中…",
    "unavailable": "此競賽尚未公開。",
    "register": "報名",
    "registering": "報名中…",
    "registerError": "無法完成報名，請稍後再試。",
    "registrationNotOpen": "目前不在報名期間。",
    "signInToRegister": "登入以報名",
    "submitEntry": "繳交作品",
    "registrationForm": "報名表單",
    "registrationFormHint": "請填寫以下表單以完成報名。",
    "importantDates": "重要日期",
    "registration": "報名",
    "submission": "作品繳交",
    "resultPublish": "結果公布",
    "tba": "待公告",
    "categories": "類別",
    "announcements": "公告",
    "eligibility": "參賽資格",
    "submissionRequirements": "作品繳交規定",
    "judgingCriteria": "評選標準",
    "prizes": "獎項",
    "organizerContact": "主辦單位聯絡方式",
    "faq": "常見問答",
    "countdown": {
      "until": "倒數計時：",
      "none": "目前沒有即將到來的截止日期。",
      "days": "天",
      "hours": "時",
      "minutes": "分"
    },
    "phaseTimeline": {
      "current": "進行中",
      "completed": "已結束"
    },
    "highlights": {
      "title": "參賽重點",
      "teamSizeRange": "每隊 {{min}}–{{max}} 人",
      "individual": "個人參賽",
      "advisorRequired": "須有指導老師",
      "advisorAllowed": "可有指導老師",
      "advisorNotAllowed": "不開放指導老師"
    },
    "process": {
      "title": "競賽流程",
      "current": "目前：{{step}}",
      "steps": {
        "registration": "報名",
        "submission": "作品繳交",
        "judging": "評選",
        "results": "結果公布"
      }
    },
    "stickyCta": {
      "action": "立即前往"
    },
    "hero": {
      "deadlineLine": "{{milestone}}：{{deadline}}",
      "viewRules": "查看競賽辦法",
      "timezoneNote": "以上時間皆以 {{timezone}} 顯示。",
      "status": {
        "published": "即將開放",
        "registration_open": "報名開放中",
        "submission_open": "作品繳交中",
        "judging": "評選中",
        "completed": "已結束"
      },
      "explanation": {
        "registration_open": "現在可以報名參加這場競賽。",
        "registration_closed_submission_open": "報名已截止。已完成報名的參賽者仍可於 {{deadline}} 前繳交作品。",
        "registration_closed_judging": "報名與作品繳交皆已截止，目前正在評選作品。",
        "not_open_generic": "此階段無法報名，請留意後續公告。",
        "completed": "本屆競賽已結束。"
      },
      "milestone": {
        "registration_opens": "報名開始",
        "registration_closes": "報名截止",
        "submission_closes": "作品繳交截止",
        "result_publication": "結果公布"
      },
      "cta": {
        "signInToRegister": "登入以報名",
        "registerNow": "立即報名",
        "completeRegistration": "完成報名",
        "manageTeam": "管理團隊",
        "submitEntry": "繳交作品",
        "continueSubmission": "繼續投稿",
        "checkAndSubmit": "檢查並送出作品",
        "correctionRequired": "查看並修正作品",
        "viewReceipt": "查看投稿收據",
        "viewSubmitted": "查看已提交作品",
        "viewResults": "查看結果",
        "registrationClosed": "報名已截止",
        "notOpenYet": "尚未開放",
        "registeredAwaitingSubmission": "已完成報名",
        "submissionMissed": "查看競賽詳情"
      }
    }
  }
}
